import { SDKModel } from '../../core/model.js';
import { DataSettings, DatasourceModel } from '../datasources.js';
export class ContentHubOneContentTypeModel extends SDKModel {
    static typeToDatasource(type, library, allTypes, url) {
        return new DatasourceModel({
            libraryId: library.id,
            id: type.name,
            name: type.name,
            description: '',
            type: 'contentHubOne',
            definition: type,
            settings: ContentHubOneContentTypeModel.generateSettings(type, library, allTypes, url),
            sample: {},
            externalSourceId: library.id
        });
    }
    static generateSettings(type, library, allTypes, url) {
        // use latest state of current type in all types (this is needed when resolving conflicts in relations of own kind)
        const allTypesWithCurrentType = allTypes.map((item) => (item.name === type.name ? type : item));
        return DataSettings({
            jsonpath: `$.data.all${type.name}.results`,
            url,
            method: 'POST',
            params: {},
            headers: { 'Content-Type': 'application/json', 'X-Gql-Token': library.settings.contentHubOneDeliveryKey },
            body: {
                query: `{
            all${type.name}(first: 10) {
              results {
                id name __sysCreatedAt
                ${generateGraphQLFields(type, allTypesWithCurrentType)}
              }
            }
          }`
            }
        });
    }
    static generateSample(type, allTypes) {
        return {
            data: {
                [`all${type.name}`]: generateFieldsFromType(type, allTypes)
            }
        };
    }
    static async fetchSample(datasource) {
        const { url, body, headers, method } = datasource.settings;
        return await datasource.sdk.fetchExternalJSON(url, { method, headers, body: JSON.stringify(body) });
    }
}
const generateGraphQLFields = (type, allTypes, visitedRelatedTypes = []) => {
    var _a;
    return (_a = type.fields) === null || _a === void 0 ? void 0 : _a.map((item) => {
        if (!item.type) {
            const itemName = item.name.endsWith('s')
                ? item.name.replace('related', '').slice(0, -1)
                : item.name.replace('related', '');
            const relatedType = allTypes === null || allTypes === void 0 ? void 0 : allTypes.find((type) => type.name === itemName);
            if (relatedType && !visitedRelatedTypes.includes(itemName)) {
                const fields = generateGraphQLFields(relatedType, allTypes, [...visitedRelatedTypes, itemName]);
                return `${item.name}
              {
                results {
                  ...on ${relatedType.name} {
                    ${fields}
                  }
                }
              }`;
            }
            else
                return '';
        }
        else
            return item.name;
    }).join(' ');
};
const generateFieldsFromType = (type, allTypes) => {
    var _a;
    return {
        results: [
            (_a = type.fields) === null || _a === void 0 ? void 0 : _a.reduce((obj, field) => {
                return {
                    ...obj,
                    [field.name]: populateField(field, allTypes)
                };
            }, {})
        ]
    };
};
const populateField = (field, allTypes) => {
    if (field.type === 'String')
        return 'sample text';
    if (field.type === 'Integer' || field.type === 'Long')
        return 1000;
    if (field.type === 'DateTime')
        return '10/10/20';
    if (field.type === 'Boolean')
        return true;
    if (field.type === 'Json')
        return {
            type: 'doc',
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            text: 'Customers want to experience uninterrupted interactions with brands — whether shopping, surfing, or asking questions — from wherever they are and on whichever device they happen to be using. If they put one device down and pick up another, they want the brand to recognize where they were previously so their journey can continue. ',
                            type: 'text'
                        }
                    ]
                },
                {
                    type: 'heading',
                    content: [
                        {
                            text: 'Headless CMS vs. traditional CMS: What’s the difference?',
                            type: 'text'
                        }
                    ],
                    attrs: {
                        level: 2
                    }
                }
            ]
        };
    // Reference
    if (!field.type) {
        const fieldName = field.name.endsWith('s')
            ? field.name.replace('related', '').slice(0, -1)
            : field.name.replace('related', '');
        const relatedType = allTypes.find((type) => type.name === fieldName);
        if (relatedType) {
            return generateFieldsFromType(relatedType, allTypes);
        }
        else {
            return null;
        }
    }
};
//# sourceMappingURL=content-hub-one-content-types.js.map